/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface DistributionRow
 */
export interface DistributionRow {
  /**
   *
   * @type {number}
   * @memberof DistributionRow
   */
  count?: number;
  /**
   *
   * @type {number}
   * @memberof DistributionRow
   */
  biomass?: number;
  /**
   *
   * @type {number}
   * @memberof DistributionRow
   */
  hog_count?: number;
  /**
   *
   * @type {number}
   * @memberof DistributionRow
   */
  hog_biomass?: number;
  /**
   *
   * @type {string}
   * @memberof DistributionRow
   */
  quality_class?: DistributionRowQualityClassEnum;
  /**
   *
   * @type {string}
   * @memberof DistributionRow
   */
  weight_class?: DistributionRowWeightClassEnum;
}

export const DistributionRowQualityClassEnum = {
  Superior: 'superior',
  Ordinary: 'ordinary',
  Production: 'production',
  Vrak: 'vrak',
} as const;

export type DistributionRowQualityClassEnum =
  (typeof DistributionRowQualityClassEnum)[keyof typeof DistributionRowQualityClassEnum];
export const DistributionRowWeightClassEnum = {
  _01: '0-1',
  _12: '1-2',
  _23: '2-3',
  _34: '3-4',
  _45: '4-5',
  _56: '5-6',
  _67: '6-7',
  _78: '7-8',
  _89: '8-9',
  _9: '9+',
} as const;

export type DistributionRowWeightClassEnum =
  (typeof DistributionRowWeightClassEnum)[keyof typeof DistributionRowWeightClassEnum];
